<template>
  <v-container class="px-6" fluid>
    <v-layout justify-space-between>
      <h1>Spreadsheets</h1>
      <v-btn fab small to="/estimate/create">
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-layout>
    <ul class="mt-6">
      <li class="">
        <a>users</a>
      </li>
      <li class="">hello</li>
    </ul>
    <!-- <v-data-table
      item-key="id"
      :headers="headers"
      :items="items"
      :server-items-length="10"
      class="mt-4"
      @update:page="getItems"
      hide-default-footer
    >
    </v-data-table> -->
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      selected: [],
      pagination: {},
      headers: [
        { sortable: false, text: "No.", align: "start", value: "id" },
        { sortable: false, text: "아이디", align: "", value: "username" },
        { sortable: false, text: "이름", align: "", value: "name" },
        { sortable: false, text: "유형", align: "start", value: "userType" },
        { sortable: false, text: "성별", align: "start", value: "gender" },
        { sortable: false, text: "생일", align: "start", value: "birth" },
        { sortable: false, text: "가입일시", value: "createdAt" },
      ],
    };
  },
  methods: {
    async getItems(n) {
      try {
        const params = { page: n };
        const { data } = await this.$axios.get(`/account`, { params });
        const { docs, page, totalPages } = data.data;
        this.items = docs.map((item) => ({
          ...this.objectTypesFormatter(item),
          createdAt: item.createdAt
            .substr(0, 19)
            .split("T")
            .join(" "),
        }));
        this.pagination = {
          page,
          totalPages,
        };
      } catch (err) {
        console.log(err);
      }
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>

<style></style>
